export const ACTION = {
  START_GAME: 'START_GAME',
  ACKNOWLEDGE_SUBSIDY: 'ACKNOWLEDGE_SUBSIDY',
  SELECT_PLANT: 'SELECT_PLANT',
  UNSELECT_PLANT: 'UNSELECT_PLANT',
  SELECT_RETIREMENT: 'SELECT_RETIREMENT',
  UNSELECT_RETIREMENT: 'UNSELECT_RETIREMENT',
  COMMIT_BUILD: 'COMMIT_BUILD',
  REVEAL_VARIABLE_ROLLS: 'REVEAL_VARIABLE_ROLLS',
  ACK_VARIABLE_ROLLS: 'ACK_VARIABLE_ROLLS',
  REVEAL_DISASTERS: 'REVEAL_DISASTERS',
  RESOLVE_YEAR: 'RESOLVE_YEAR',
  ADVANCE_YEAR: 'ADVANCE_YEAR',
  REVEAL_COP30: 'REVEAL_COP30',
  FINALISE_GAME: 'FINALISE_GAME',
  RESTART: 'RESTART'
};

export const startGame = (seed, mode) => ({ type: ACTION.START_GAME, seed, mode });
export const acknowledgeSubsidy = () => ({ type: ACTION.ACKNOWLEDGE_SUBSIDY });
export const selectPlant = (plantId) => ({ type: ACTION.SELECT_PLANT, plantId });
export const unselectPlant = (index) => ({ type: ACTION.UNSELECT_PLANT, index });
// Advanced Capacity Mode only: retirement during the build phase.
export const selectRetirement = (plantId) => ({
  type: ACTION.SELECT_RETIREMENT,
  plantId
});
export const unselectRetirement = (index) => ({
  type: ACTION.UNSELECT_RETIREMENT,
  index
});
export const commitBuild = () => ({ type: ACTION.COMMIT_BUILD });
export const revealVariableRolls = () => ({ type: ACTION.REVEAL_VARIABLE_ROLLS });
export const ackVariableRolls = () => ({ type: ACTION.ACK_VARIABLE_ROLLS });
export const revealDisasters = () => ({ type: ACTION.REVEAL_DISASTERS });
export const resolveYear = () => ({ type: ACTION.RESOLVE_YEAR });
export const advanceYear = () => ({ type: ACTION.ADVANCE_YEAR });
export const revealCop30 = () => ({ type: ACTION.REVEAL_COP30 });
export const finaliseGame = () => ({ type: ACTION.FINALISE_GAME });
export const restart = (seed) => ({ type: ACTION.RESTART, seed });
